'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddToPlaylistIcon = function AddToPlaylistIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M4,19 C4,18.4477153 4.4463114,18 4.99754465,18 L12.0024554,18 C12.553384,18 13,18.4438648 13,19 C13,19.5522847 12.5536886,20 12.0024554,20 L4.99754465,20 C4.44661595,20 4,19.5561352 4,19 Z M4,14 C4,13.4477153 4.44994876,13 5.00684547,13 L16.9931545,13 C17.5492199,13 18,13.4438648 18,14 C18,14.5522847 17.5500512,15 16.9931545,15 L5.00684547,15 C4.45078007,15 4,14.5561352 4,14 Z M4,9 C4,8.44771525 4.44994876,8 5.00684547,8 L16.9931545,8 C17.5492199,8 18,8.44386482 18,9 C18,9.55228475 17.5500512,10 16.9931545,10 L5.00684547,10 C4.45078007,10 4,9.55613518 4,9 Z M23,18 L23,14.001 C23,13.448 22.574,13 22.021,13 C21.468,13 21.021,13.447 21.021,13.999 L21.012,18 L17,18 C16.447,18 16,18.447 16,19 C16,19.552 16.447,20 17,20 L21.01,20 L21,23.999 C20.999,24.551 21.446,24.999 21.998,25 C22.551,25 22.999,24.553 23,24.001 L23,20 L27,20 C27.552,20 28,19.552 28,19 C28,18.447 27.552,18 27,18 L23,18 Z' })
  );
};

AddToPlaylistIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = AddToPlaylistIcon;